import React, { memo } from 'react';
import { Box, Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import CLSFCN from 'constants/classification';
import COMMON from 'constants/common';
import { getClassificationName } from 'utils/common.helper';

type StyleProps = {
  isLeft: boolean;
};

type LevelManagementProps = {
  isLeft: boolean;
  isleverOperation: boolean;
  leverTime: string;
};

const useStyles = makeStyles<StyleProps>()((theme, { isLeft }) => ({
  mainContainer: {
    marginBottom: '24px',
    borderRadius: 4,
    height: '55px',
    border: `2px solid ${isLeft ? theme.leftStation.contentsBorder : theme.rightStation.contentsBorder}`,
  },
  container: {
    display: 'flex',
    height: '100%',
  },
  levelTextStyle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRight: `2px solid ${isLeft ? theme.leftStation.contentsBorder : theme.rightStation.contentsBorder}`,
    width: '150px',
    fontSize: 24,
  },
  contentStyle: {
    display: 'flex',
    background: '#ffffff',
    alignItems: 'center',
    width: '162px',
  },
  valueStyle: {
    marginLeft: '8px',
    fontSize: 20,
  },
}));

const LeverManagement: React.FC<React.PropsWithChildren<LevelManagementProps>> = (props) => {
  const { isLeft, isleverOperation, leverTime } = props;
  const { classes } = useStyles({ isLeft });

  const leverTimeString = isleverOperation
    ? getClassificationName(CLSFCN.LEVER_TIME.CATEGORY_CD, leverTime)
    : COMMON.BLANK3;
  return (
    <Box className={classes.mainContainer}>
      <Box className={classes.container}>
        <div className={classes.levelTextStyle}>
          <span>レバー運営</span>
        </div>
        <div className={classes.contentStyle}>
          <span className={classes.valueStyle}>{leverTimeString}</span>
        </div>
      </Box>
    </Box>
  );
};

export default memo(LeverManagement);
